import { render, staticRenderFns } from "./PartnerReportInitialize.vue?vue&type=template&id=b4bc33e8&scoped=true&"
import script from "./PartnerReportInitialize.vue?vue&type=script&lang=ts&"
export * from "./PartnerReportInitialize.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerReportInitialize.vue?vue&type=style&index=0&id=b4bc33e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bc33e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
